import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { USER_FEEDBACK_STORE_KEY } from '../constants'
import { useStoreSelector } from '@ublique/platform'
import { STORE_KEY } from 'pages/ExtraOutput/constants'
import { selectors } from 'pages/ExtraOutput/state'
import { userSelectors } from '../state'
import { fetchDetailInfoData } from '../actions'
import { isEmpty, isNull, keys } from 'lodash'
import '../index.scss'

const formatData = (data, t) => {
  if (isEmpty(data)) return [data, data, data, data]
  const roundData = (str) => {
    if (isEmpty(str)) return str

    const num = str.split(' ')[0]

    return Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100 + ' €'
  }
  return keys(data)
    .sort()
    .map((key) => {
      return {
        headerTitle: t(`UserFeedback.KPI.${key.toUpperCase()}`),
        title: `${t('UserFeedback.KPI.VALUE')} : ${roundData(
          data[key].value
        )} `,
        value: `${t('UserFeedback.KPI.ARTICLE_NUM')} : ${data[key].items}`,
        infoMessage: t(`UserFeedback.KPI.Tooltip.${key.toUpperCase()}`)
      }
    })
}

function useDetailKpisConfig({ key }) {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState()
  const { t } = useTranslation('ExtraOutput')

  const filters = useStoreSelector(STORE_KEY, selectors.getFilters)
  const uom = useStoreSelector(USER_FEEDBACK_STORE_KEY, userSelectors.getUom)
  const selectedRow = useStoreSelector(
    USER_FEEDBACK_STORE_KEY,
    userSelectors.getSelectedRow
  )

  const fetchParams = useMemo(
    () => ({
      store: filters.store,
      uom,
      id: selectedRow?.id,
      room: selectedRow?.room
    }),
    [filters, uom, selectedRow]
  )

  useEffect(() => {
    async function fetchData() {
      try {
        if (!isNull(selectedRow)) {
          setLoading(true)
          const res = await fetchDetailInfoData(fetchParams)
          if (res) {
            setData(formatData(res, t))
          }
        } else {
          setData([])
        }
      } catch (error) {
        console.warn(error)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [setData, fetchParams, selectedRow, t, key])

  const kpis = useMemo(
    () =>
      isEmpty(data)
        ? [
            {
              config: { sm: 4, md: 8, lg: 12 },
              factory: 'KPIS',
              factoryConfig: {
                data: [],
                type: 'SINGLE_TEXT',
                noDataLabel: t('SELECT_ROW'),
                isLoading: loading
              }
            }
          ]
        : data.map((kpiData) => ({
            config: { sm: 4, md: 8, lg: 3 },
            factory: 'KPIS',
            factoryConfig: {
              infoButton: { enabled: true, message: kpiData?.infoMessage },
              headerTitle: kpiData.headerTitle,
              data: kpiData,
              type: 'SINGLE_TEXT',
              noDataLabel: t('NO_DATA'),
              isLoading: loading
            }
          })),
    [data, loading, t]
  )

  return kpis
}

export default useDetailKpisConfig
